import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae50fb76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav__left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "左移", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "右移", -1))
const _hoisted_4 = { class: "nav__right" }
const _hoisted_5 = ["onContextmenu"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看所有标签页", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加标签页", -1))

import { ref, reactive, computed, watch } from 'vue'
import type { ComponentPublicInstance } from 'vue'
import Draggable from 'vuedraggable'
import { NTooltip } from 'naive-ui'
import type { TreeOption } from 'naive-ui'
import { useResizeObserver } from '@vueuse/core'
import NavItem from './nav.vue'
import useNav from '../useNav'
import type { TreeNavOption } from '../types'
import TreeNav from './treeNav.vue'
import aclRules from '@teams/common/acl/aclRules'
import Icon from '@teams/common/components/icon'
import { useAcl } from 'vue-simple-acl'
import { Nav } from '@teams/common/models'
import useMitt from '@/hooks/useMitt'
import { events, elementIds } from '@/constants'
import handleResponseError from '@teams/common/hooks/useResponseError'

type DraggaleChangeEvents = 'added' | 'removed' | 'moved'

interface DraggaleChangeEventParams<T> {
  element: T
  newIndex?: number
  oldIndex?: number
}

type DraggaleChangeParams<T> = Record<
  DraggaleChangeEvents,
  DraggaleChangeEventParams<T>
>


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    customStyles: { default: () => ({
      backgroundColor: 'var(--PC-nav-background-color, var(--theme-team-02))'
    }) }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "7d905b6a": (__props.customStyles.backgroundColor)
}))



// 12.20 暂时屏蔽
// const { customStyles } = toRefs(props)
const emitter = useMitt()
const {
  navSortable,
  activeNavId,
  navs,
  checkIsNavActive,
  showNavBarOptions,
  showNavOptions,
  toViewContent,
  showIcon,
  treeNavs,
  treeNavNodeProps,
  findParentNav,
  handleTreeNavDrop,
  updateNavOrder,
  addSubNav,
  addNav,
  selectedTreeNavIds,
  expandedNavIds,
  onExpandedNavIdsChange,
  findHighlightNavId
} = useNav()

function onAddSubNavClick(params: TreeOption) {
  addSubNav(params.data as Nav)
}

const addNavRef = ref<ComponentPublicInstance>()
const isShowPopover = ref(false)
watch(addNavRef, value => {
  if (value) {
    emitter.emit(events.elementRendered, {
      key: elementIds.addNavBtn,
      value: value
    })
  }
})

const popoverState = reactive({
  visible: false,
  x: 0,
  y: 0,
  nav: undefined as Nav | undefined,
  expandedNavIds: [] as number[]
})
const popoverTreeNavs = computed<TreeNavOption[]>(() => {
  const nav = popoverState.nav
  if (!nav) {
    return []
  }
  const root = findParentNav(navs.value as Nav[], nav.id)
  const rootNode = treeNavs.value.find(n => n.key === root?.id)
  return rootNode ? [rootNode] : []
})

const partialSelectedTreeNavIds = computed(() => {
  const nid = findHighlightNavId(
    navs.value as Nav[],
    popoverState.expandedNavIds,
    activeNavId.value
  )
  return nid !== undefined ? [nid] : []
})

function onPartialExpandedNavIdsChange(keys: number[]) {
  popoverState.expandedNavIds = keys
}

function showTreeNavPopover(container: HTMLElement, nav: Nav) {
  const { x, y } = container.getBoundingClientRect()
  popoverState.x = x
  popoverState.y = y + 30
  popoverState.nav = nav
  popoverState.visible = true
  const root = findParentNav(navs.value as Nav[], nav.id)
  if (root) {
    popoverState.expandedNavIds = navs.value
      .filter(item => item.idPath.includes(root.id))
      .map(item => item.id)
  }
}

function closeTreeNavPopover() {
  popoverState.visible = false
}

const navLeftInnerRef = ref<any>()
const navBarProperties = reactive({
  scrollWidth: 0,
  clientWidth: 0
})
const navBarOffsetX = ref(0) // 用 useScroll 体验较差

useResizeObserver(navLeftInnerRef, mutations => {
  const [navLeftInnerRecord] = mutations
  const target = navLeftInnerRecord.target as HTMLElement
  if (target) {
    navBarProperties.scrollWidth = target.scrollWidth
    navBarProperties.clientWidth = target.clientWidth
  }
})

const scrollOffset = 120

const enableScrollLeftBtn = computed(() => navBarOffsetX.value > 0)
const enableScrollRightBtn = computed(
  () =>
    navBarOffsetX.value <
    navBarProperties.scrollWidth - navBarProperties.clientWidth
)

const scrollBtnStrokeStyles = computed(() => ({
  left: enableScrollLeftBtn.value ? 'var(--icon-02)' : 'var(--icon-04)',
  right: enableScrollRightBtn.value ? 'var(--icon-02)' : 'var(--icon-04)'
}))

function scrollNavBar(left: number) {
  if (!navLeftInnerRef.value) {
    return
  }
  const value = Math.max(
    0,
    Math.min(left, navBarProperties.scrollWidth - navBarProperties.clientWidth)
  )
  navBarOffsetX.value = value
  navLeftInnerRef.value.targetDomElement?.scrollTo({
    left: value,
    behavior: 'smooth'
  })
}

function scrollLeft() {
  scrollNavBar(navBarOffsetX.value - scrollOffset)
}

function scrollRight() {
  scrollNavBar(navBarOffsetX.value + scrollOffset)
}

function onNavBarWheel(e: WheelEvent) {
  // 没有 shiftKey 即为垂直滚动
  if (!e.shiftKey) {
    scrollNavBar(navBarOffsetX.value + e.deltaY)
  }
}

const acl = useAcl()
const showNavAdd = computed(() => acl.can(aclRules.navigation_add_tag))
const dragging = ref(false)

function startDragging() {
  dragging.value = true
}

function stopDragging() {
  dragging.value = false
}

function checkArrowVisible(nav: Nav) {
  const rootNav = findParentNav(navs.value as Nav[], nav.id)
  const rootNavNode = treeNavs.value.find(n => n.key === rootNav?.id)
  return !!rootNavNode?.children?.length
}

const visibleNavs = computed<Nav[]>(() => {
  const firstLevelNodes = treeNavs.value // 一级节点导航
  const activeNavRoot = findParentNav(navs.value as Nav[], activeNavId.value)
  const activeNav = navs.value.find(nav => nav.id === activeNavId.value) as
    | Nav
    | undefined
  return firstLevelNodes.map(node => {
    // 若 active nav 在当前节点分支下，则显示 active nav
    if (node.data.id === activeNavRoot?.id) {
      return activeNav || node.data
    }
    return node.data
  })
})

async function onNavOrderChange(e: DraggaleChangeParams<Nav>) {
  const { moved } = e
  if (!moved) {
    return
  }
  try {
    const { element, newIndex = 0, oldIndex = 0 } = moved
    const firstLevelNavs = treeNavs.value.map(n => n.data)
    const rootNav = findParentNav(navs.value as Nav[], element.id)
    firstLevelNavs.splice(oldIndex, 1)
    firstLevelNavs.splice(newIndex, 0, rootNav || element)
    const next =
      newIndex + 1 < firstLevelNavs.length
        ? firstLevelNavs[newIndex + 1]
        : undefined
    await updateNavOrder(element.id, next?.id || -1)
  } catch (e) {
    handleResponseError(e)
  }
}

const hiddenNavs = ref<Nav[]>([])

const updateNavVisibility = (navId: number, visible: boolean) => {
  if (dragging.value) {
    // 拖拽时可能把元素拖出父元素外，此时可见性是 false 的
    // 但不应该因此出现 "更多" 菜单
    return
  }
  const nav = visibleNavs.value.find(nav => nav.id === navId)
  if (!nav) {
    return
  }
  if (visible) {
    hiddenNavs.value = hiddenNavs.value.filter(nav => nav.id !== navId)
  } else {
    hiddenNavs.value = [nav, ...hiddenNavs.value]
  }
}
const togglePopoverState = () => {
  isShowPopover.value = !isShowPopover.value
}
const closePopover = () => {
  isShowPopover.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_n_popover = _resolveComponent("n-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: "nav__container",
    onContextmenu: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(showNavBarOptions) && _unref(showNavBarOptions)(...args)), ["prevent","stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (hiddenNavs.value.length)
        ? (_openBlock(), _createBlock(_unref(NTooltip), {
            key: 0,
            trigger: "hover",
            placement: "bottom",
            style: {"max-width":"220px","padding":"8px 12px"}
          }, {
            trigger: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["common-icon scroll-left__btn", { disable__btn: !_unref(enableScrollLeftBtn) }]),
                onClick: scrollLeft
              }, [
                _createVNode(_unref(Icon), {
                  name: "packUp1",
                  fill: "transparent",
                  stroke: _unref(scrollBtnStrokeStyles).left
                }, null, 8, ["stroke"])
              ], 2)
            ]),
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(Draggable), {
        class: "nav-left__inner",
        ref_key: "navLeftInnerRef",
        ref: navLeftInnerRef,
        "component-data": {
          type: 'transition-group',
          name: 'fade'
        },
        "item-key": "id",
        disabled: !_unref(navSortable),
        "model-value": _unref(visibleNavs),
        animation: 200,
        onStart: startDragging,
        onEnd: stopDragging,
        onChange: onNavOrderChange,
        onWheel: onNavBarWheel
      }, {
        item: _withCtx(({ element }) => [
          _createVNode(NavItem, {
            icon: _unref(showIcon) ? element.icon : '',
            name: element.name,
            active: _unref(checkIsNavActive)(element),
            "show-arrow": checkArrowVisible(element),
            "onUpdate:visibility": 
              visible => updateNavVisibility(element.id, visible)
            ,
            onClick: ($event: any) => (_unref(toViewContent)(element)),
            "onClick:arrow": container => showTreeNavPopover(container, element),
            onContextmenu: _withModifiers(e => _unref(showNavOptions)(e, element), ["prevent","stop"])
          }, null, 8, ["icon", "name", "active", "show-arrow", "onUpdate:visibility", "onClick", "onClick:arrow", "onContextmenu"])
        ]),
        _: 1
      }, 8, ["disabled", "model-value"]),
      (hiddenNavs.value.length)
        ? (_openBlock(), _createBlock(_unref(NTooltip), {
            key: 1,
            trigger: "hover",
            placement: "bottom",
            style: {"max-width":"220px","padding":"8px 12px"}
          }, {
            trigger: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["common-icon scroll-right__btn", { disable__btn: !_unref(enableScrollRightBtn) }]),
                onClick: scrollRight
              }, [
                _createVNode(_unref(Icon), {
                  name: "packUp1",
                  fill: "transparent",
                  stroke: _unref(scrollBtnStrokeStyles).right
                }, null, 8, ["stroke"])
              ], 2)
            ]),
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (hiddenNavs.value.length)
        ? (_openBlock(), _createBlock(_component_n_popover, {
            key: 0,
            trigger: "click",
            placement: "bottom-start",
            scrollable: "",
            style: {"max-height":"calc(100vh - 150px)","background-color":"var(--background-01)","color":"var(--text-01)"},
            "content-style": "padding: 0 4px",
            width: 240,
            "show-arrow": false,
            show: isShowPopover.value,
            onClickoutside: closePopover,
            class: "horizontalChildTreeNav"
          }, {
            trigger: _withCtx(() => [
              _createVNode(_unref(NTooltip), {
                trigger: "hover",
                placement: "bottom",
                style: {"max-width":"220px","padding":"8px 12px"}
              }, {
                trigger: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "common-icon nav-more-icon",
                    onClick: togglePopoverState,
                    onContextmenu: _withModifiers(closePopover, ["prevent"])
                  }, [
                    _createVNode(_unref(Icon), {
                      name: "navMoreOption",
                      size: 16
                    })
                  ], 40, _hoisted_5)
                ]),
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(TreeNav, {
                draggable: _unref(navSortable),
                "expanded-keys": _unref(expandedNavIds),
                "selected-keys": _unref(selectedTreeNavIds),
                data: _unref(treeNavs),
                "node-props": _unref(treeNavNodeProps),
                "on-update:expanded-keys": _unref(onExpandedNavIdsChange),
                "onAdd:subNav": onAddSubNavClick,
                onDrop: _unref(handleTreeNavDrop)
              }, null, 8, ["draggable", "expanded-keys", "selected-keys", "data", "node-props", "on-update:expanded-keys", "onDrop"])
            ]),
            _: 1
          }, 8, ["show"]))
        : _createCommentVNode("", true),
      (_unref(showNavAdd))
        ? (_openBlock(), _createBlock(_unref(NTooltip), {
            key: 1,
            trigger: "hover",
            placement: "bottom",
            style: {"max-width":"220px","padding":"8px 12px"}
          }, {
            trigger: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['common-icon', { 'create-new-nav': hiddenNavs.value.length }]),
                ref_key: "addNavRef",
                ref: addNavRef,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(addNav) && _unref(addNav)(...args)))
              }, [
                _createVNode(_unref(Icon), {
                  name: "add",
                  fill: "transparent"
                })
              ], 2)
            ]),
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_n_popover, {
      trigger: "manual",
      placement: "bottom-start",
      scrollable: "",
      style: {"max-height":"calc(100vh - 150px)","background-color":"var(--background-01)","color":"var(--text-01)"},
      "content-style": "padding: 0 4px",
      "show-arrow": false,
      show: popoverState.visible,
      width: 232,
      x: popoverState.x,
      y: popoverState.y,
      onClickoutside: closeTreeNavPopover,
      class: "horizontalChildTreeNav"
    }, {
      default: _withCtx(() => [
        _createVNode(TreeNav, {
          draggable: _unref(navSortable),
          "expanded-keys": popoverState.expandedNavIds,
          "selected-keys": _unref(partialSelectedTreeNavIds),
          data: _unref(popoverTreeNavs),
          "node-props": _unref(treeNavNodeProps),
          "on-update:expanded-keys": onPartialExpandedNavIdsChange,
          "onAdd:subNav": onAddSubNavClick,
          onDrop: _unref(handleTreeNavDrop)
        }, null, 8, ["draggable", "expanded-keys", "selected-keys", "data", "node-props", "onDrop"])
      ]),
      _: 1
    }, 8, ["show", "x", "y"])
  ], 32))
}
}

})